module.exports = __webpack_public_path__ + "assets/img/4-1.9c8a35bd.jpg";